import { useQueryClient } from "@tanstack/react-query";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { useNotify } from "_common/component/NotifyProvider";
import { useStores } from "_common/hooks";

const DesktopLayout = observer(() => {
  const queryClient = useQueryClient();
  const { notify, setNotify } = useNotify();
  const {
    authStore: { user, loading },
  } = useStores();

  return (
    <div className="tw-dark">
      <div className="desktop-layout text-white w-full h-full">
        <Outlet />
      </div>
    </div>
  );
});

export default DesktopLayout;
